var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17.864,
  height: 17.864,
  viewBox: "0 0 17.864 17.864"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_feather-message-square",
  "data-name": "Icon feather-message-square",
  d: "M20.564,15.209a1.785,1.785,0,0,1-1.785,1.785H8.07L4.5,20.564V6.285A1.785,1.785,0,0,1,6.285,4.5H18.779a1.785,1.785,0,0,1,1.785,1.785Z",
  transform: "translate(-3.6 -3.6)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.8
})));
export { SvgSmsIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/smsIcon.1b46d785d3517e5271b8a50b4c509fc8.svg";